(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

       // Track the menu drawer so we can pause header hide/reveal while it's open
      this.menuDetails = document.querySelector('#Details-menu-drawer-container');
      this.menuIsOpen = !!(this.menuDetails && this.menuDetails.hasAttribute('open'));
      if (this.menuDetails) {
        this.menuDetails.addEventListener('toggle', () => {
          this.menuIsOpen = this.menuDetails.hasAttribute('open');
        });
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight(){
      if (!this.header) return;
      const headerRect = this.header.getBoundingClientRect();
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      // Also expose the header's bottom edge for drawer height/position calculations
      document.documentElement.style.setProperty('--header-bottom-position', `${Math.round(headerRect.bottom)}px`);
    }
    disconnectedCallback(){
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver(){
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect; observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll(){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // If the menu drawer is open, keep the header and drawer stable and
      // skip all hide/reveal logic so menu links don't disappear while scrolling.
      if (
        this.menuIsOpen ||
        document.body.classList.contains('menu-open') ||
        document.body.classList.contains('menu-opening')
      ) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return; requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset(){ if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
    closeMenuDisclosure(){ this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach(d=>d.close()); }
    closeSearchModal(){ this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  /* ALD: Ensure menu drawer close button never leaves body scroll-locked */
  (function() {
    const detailsEl = document.querySelector('#Details-menu-drawer-container');
    if (!detailsEl) return;

    const hardUnlockScroll = () => {
      // Remove any body/html lock classes that might have been left behind
      document.body.classList.remove('menu-open', 'menu-opening', 'scroll-locked');
      document.documentElement.classList.remove('vh-lock', 'scroll-locked');
      // Clear any inline scroll lock styles
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('overflow');
    };

    // When the drawer closes (details loses "open"), force-unlock scroll
    detailsEl.addEventListener('toggle', () => {
      if (!detailsEl.hasAttribute('open')) {
        hardUnlockScroll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
